// extracted by mini-css-extract-plugin
export default {"search":"Promotions_search__VwIUD","promotions":"Promotions_promotions__EMP1k","promotion-wrapper":"Promotions_promotion-wrapper__FA-pC"};